import { Component, OnInit, Inject } from '@angular/core';
import { DialogViewGroupsComponent } from 'src/app/configuration/users-and-groups/dialog-view-groups/dialog-view-groups.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HoldsService } from 'src/app/_services/holds.services';

@Component({
  selector: 'app-dialog-remove-hold',
  templateUrl: './dialog-remove-hold.component.html',
  styleUrls: ['./dialog-remove-hold.component.scss']
})
export class DialogRemoveHoldComponent implements OnInit {

  isHoldApplied: boolean = false;
  constructor(
    private holdsService: HoldsService,
    public dialogRef: MatDialogRef<DialogRemoveHoldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  removeHold(){
    this.holdsService.removeHold(this.data.documentID).subscribe(data => {
      console.log("inside");
      this.isHoldApplied = true
      this.data.holdApplied = false;
      this.data.onHold = false;
      this.data.holdID = null 
      this.dialogRef.close(this.isHoldApplied);      
      })
    
  }


  onClose(): void {
    this.dialogRef.close();
  }
}
